"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Text = _interopRequireDefault(require("../Text"));
var __jsx = _react.default.createElement;
var SpeakerPage = function SpeakerPage(props) {
  var speakerName = props.speakerName,
    speakerTitle = props.speakerTitle,
    speakerPicture = props.speakerPicture,
    speakerCompany = props.speakerCompany,
    speakerBio = props.speakerBio;
  if (!speakerName && !speakerTitle) return null;
  var pictureStyle = {
    width: '100px',
    height: '100px'
  };
  var bioStyle = {
    marginTop: '10px'
  };
  return __jsx("div", null, __jsx("img", {
    src: speakerPicture,
    style: pictureStyle,
    alt: speakerName
  }), __jsx("div", {
    className: "speakersdescription"
  }, __jsx("p", null, __jsx("strong", {
    dangerouslySetInnerHTML: {
      __html: speakerName
    }
  })), speakerCompany && __jsx("p", {
    dangerouslySetInnerHTML: {
      __html: speakerCompany
    }
  }), __jsx("p", {
    dangerouslySetInnerHTML: {
      __html: speakerTitle
    }
  })), speakerBio && __jsx("div", {
    style: bioStyle
  }, __jsx(_Text.default, {
    text: speakerBio
  })));
};
var SpeakerPageEditConfig = {
  emptyLabel: 'Speaker',
  isEmpty: function isEmpty(props) {
    if (props.speakerName && props.speakerTitle) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/speakerpage')(SpeakerPage, SpeakerPageEditConfig);
exports.default = _default;